// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"854":"247690bc0a56b4251834","877":"780b6c3c73d8291dcb54"}[chunkId] + ".2157.js";
};